import { Injectable } from '@angular/core';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { Item } from 'app/models2/inventory/item';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { HttpService, MessageService } from 'brainloper-ui';

@Injectable({
  providedIn: 'root'
})
export class ItemsService {

  constructor(
    private message: MessageService,
    private http: HttpService,) { }

    private inactivateItem: string = `${EndpointDictionary.Item.INACTIVATE_ITEM}`;
    private activeItem: string = `${EndpointDictionary.Item.ACTIVE_ITEM}`;
  
    public async inactivateOrActiveItem($event: Array<Item>, active:boolean) : Promise<boolean>{
      return new Promise(async (resolve, rejects) => {
        let url = `${this.activeItem}`
        if(!active){
          url = `${this.inactivateItem}`
        }
          let cuanti: string = ''
          if ($event.length == 1) {
            cuanti = `Desea ${active?'activar':'inactivar'} Item`
          } else {
            cuanti = `Desea ${active?'activar':'inactivar'}  Item`
          }
          this.message.Warning(cuanti, ``, true).then(
            async (res: boolean) => {
              if (res == true) {
  
                try {
                  let ItemsNoInactivate = []
                  this.message.openLoading('Cargando', `${active?'Activando':'Desactivando'} Item`)
                  for (const element of $event) {
                    let res = await this.http.putDataBody<GenericResponse>(url, {
                      "id": element.id 
                    } )
                    if(res.affected == 0){
                      ItemsNoInactivate.push(element)
                    }
                  }
                  if(ItemsNoInactivate.length > 0){
                    for (let item of ItemsNoInactivate){
                      this.message.Warning('Alerta', `El item ${item.itemName} no se puede inactivar ya que debe tener 0 existencias`)
                    }
                  }else{
                    if ($event.length == 1) {
                      this.message.SuccessToast(`Item ${active?'activado':'desactivado'} correctamente`)
    
                    } else {
                      this.message.SuccessToast(`Item ${active?'activados':'desactivados'} correctamente`)
    
                    }
                  }  
  
                  resolve(res);
                  this.message.closeLoading()
                } catch (error) {
                  rejects(error)
                }
  
              } else {
                resolve(res);
              }
            }
          )
  
  
      })
  
    }
}
